"use client"
import { FC } from "react"

import { useFilters } from "@/components/Filters/useFilters"
import { FilterButton } from "@/elements"
import { graphql } from "@/gql"
import { GetHirePageFilterCountsDocument, JobPostingStatus } from "@/gql/graphql"
import type { NovaSession } from "@/types"
import { useQuery } from "@apollo/client"
import { useSearchParams } from "next/navigation"

graphql(`
  query GetHirePageFilterCounts($id: ID!, $isClient: Boolean!) {
    creative(id: $id) @skip(if: $isClient) {
      __typename
      id
      draftJobPostingCount
      activeJobPostingCount
      archivedJobPostingCount
    }
    client(id: $id) @include(if: $isClient) {
      __typename
      id
      draftJobPostingCount
      activeJobPostingCount
      archivedJobPostingCount
    }
  }
`)

interface Props {
  serverSession: NovaSession
}
export const JOB_POST_STATUS_FILTER = "status"

export const MyJobPostFilters: FC<Props> = ({ serverSession }) => {
  const searchParams = useSearchParams()
  const { toggleFilter } = useFilters()

  const { data } = useQuery(GetHirePageFilterCountsDocument, {
    variables: {
      id: serverSession.account === "client" ? serverSession.user.client.id! : serverSession.user.creative.id!,
      isClient: serverSession.account === "client",
    },
    context: {
      version: 2,
    },
  })

  const currentUser = serverSession.account === "client" ? data?.client : data?.creative

  const statusFilter = searchParams?.get(JOB_POST_STATUS_FILTER) as JobPostingStatus | null

  return (
    <div className="flex flex-row gap-2 py-4">
      <FilterButton
        label="Active"
        onClick={() => {
          toggleFilter({
            params: [{ key: JOB_POST_STATUS_FILTER, values: [JobPostingStatus.Published] }],
            multiSelect: false,
          })
        }}
        active={statusFilter === JobPostingStatus.Published || !statusFilter}
        hasDropdown={false}
        count={
          !!currentUser?.activeJobPostingCount && currentUser?.activeJobPostingCount > 0
            ? currentUser?.activeJobPostingCount
            : undefined
        }
      />
      <FilterButton
        label="Drafts"
        onClick={() =>
          toggleFilter({
            params: [{ key: JOB_POST_STATUS_FILTER, values: [JobPostingStatus.Draft] }],
            multiSelect: false,
          })
        }
        active={statusFilter === JobPostingStatus.Draft}
        hasDropdown={false}
        count={
          !!currentUser?.draftJobPostingCount && currentUser?.draftJobPostingCount > 0
            ? currentUser?.draftJobPostingCount
            : undefined
        }
      />
      <FilterButton
        label="Closed"
        onClick={() =>
          toggleFilter({
            params: [{ key: JOB_POST_STATUS_FILTER, values: [JobPostingStatus.Closed] }],
            multiSelect: false,
          })
        }
        active={statusFilter === JobPostingStatus.Closed}
        hasDropdown={false}
        count={
          !!currentUser?.archivedJobPostingCount && currentUser?.archivedJobPostingCount > 0
            ? currentUser?.archivedJobPostingCount
            : undefined
        }
      />
    </div>
  )
}
